<template>
<div class="container-fluid servicos"  id="services">
              <h2 class="h2 section-title underline">OUR SERVICES</h2>

    <div class="container">
    <div class="nossos-servicos">
        <div class="services">
        <div class="img">
            <img src="/img/strategy1.png" alt="">
        </div>
        <div class="copy-services">
            <h3>Strategy</h3>
            <ul>
                <li>Diagnóstico estratégico</li>
                <li>Planeamento estratégico</li>
                <li>Definição de posicionamento</li>
                <li>Objectivos e métricas</li>
                <li>Planos de acção claros e executáveis</li>
            </ul>
        </div>
    </div>
        <div class="services">
        <div class="img">
            <img src="/img/people2.png" alt="">
        </div>
        <div class="copy-services">
            <h3>Culture, Talent and Leadership</h3>
            <ul>
                <li>Diagnóstico cultural</li>
                <li>Desenvolvimento de lideranças</li>
                <li>Alinhamento de equipas</li>
                <li>Programas de capacitação</li>
                <li>Performance e engajamento</li>
            </ul>
        </div>
    </div>
    <div class="services">
          
        <div class="img">
            <img src="/img/revenue3.png" alt="">
        </div>
        <div class="copy-services">
            <h3>Revenue</h3>
            <ul>
                <li>Estruturação de modelos comerciais</li>
                <li>Optimização de processos de vendas</li>
                <li>Estratégias de crescimento</li>
                <li>Identificação de oportunidades</li>
                <li>Aceleração de resultados financeiros</li>
            </ul>
        </div>
    </div>
     
</div>
</div>
</div>
</template>

<style scoped>
.container-fluid{
    margin-top: 7%;


 background-color: var(--title-color);
}
.container{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5%;
}

.nossos-servicos{
    display: flex;
      justify-content: center;
    align-items: center;
    gap: 2%;
    padding: 2%;
    width: 100%;
}
.nossos-servicos .services{
    width: 50%;
}
.img{
    width: 20%;
    margin-bottom: 2%;
}
.img img{
    width: 100%;
}

.copy-services h3{
    text-align: left;
    font-weight: bold;
    margin-left: 6%;
    color: white;
  
}
.copy-services ul li{
list-style: circle;
margin-left: 2%;
color: var(--menu-color);
}

h2{
    margin-top: 2%;
    padding-top: 2%;
    text-align: center !important;
    color:white !important;
}
.section-title{
    color: white !important;
}

.underline {
    position: relative;
}

.underline::before {
    content: "";
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    width: 70%;
    height: 6px;

    background: var(--gradient-3) !important;
}
.section-title{
margin-bottom: 0 !important;
}

@media (max-width: 576px){
  .services {
    width: 100%;
    margin-bottom: 2%;

 }
 .img img{
    margin: 10%;
 }
 .nossos-servicos{
    flex-wrap: wrap;
 }
}

@media (max-width: 767px) {
.services {
    width: 100% !important;
    margin-bottom: 2%;

 }
}
</style>

<script>
import ScrollReveal from 'scrollreveal';
  export default{
      mounted() {
    ScrollReveal().reveal('.services', {
      origin: 'top',
      distance: '50px',
      duration: 3000,
      delay: 70,
      reset: true,
      origin:'left'
    });


  }
  }
</script>
